import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../../graphql/types.generated';
export type ArchiveAccountConnectionMutationVariables = GraphQLTypes.Exact<{
  input: GraphQLTypes.ArchiveAccountConnectionInput;
}>;

export type ArchiveAccountConnectionMutationResult = { __typename?: 'Mutation' } & {
  archiveAccountConnection?: GraphQLTypes.Maybe<
    { __typename?: 'ArchiveAccountConnectionPayload' } & {
      errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message' | 'path'>>>;
    }
  >;
};

export const ArchiveAccountConnectionDocument = gql`
  mutation archiveAccountConnection($input: ArchiveAccountConnectionInput!) {
    archiveAccountConnection(input: $input) {
      errors {
        message
        path
      }
    }
  }
`;
